// Componente de navegação entre etapas

import React from "react";
import { HiArrowLeft, HiArrowRight, HiCheckCircle } from "react-icons/hi";

interface OrcamentoNavigationProps {
  etapaAtual: number;
  totalEtapas: number;
  onProxima: () => void;
  onAnterior: () => void;
  onFinalizar: () => void;
  isLoading: boolean;
  isEtapaValida: boolean;
}

export const OrcamentoNavigation: React.FC<OrcamentoNavigationProps> = ({
  etapaAtual,
  totalEtapas,
  onProxima,
  onAnterior,
  onFinalizar,
  isLoading,
}) => {
  const isFirstStep = etapaAtual === 1;
  const isLastStep = etapaAtual === totalEtapas;

  return (
    <div className="flex justify-between items-center gap-4 mt-8 pt-6 border-t">
      {/* Botão Anterior */}
      {!isFirstStep && (
        <button
          type="button"
          onClick={onAnterior}
          disabled={isLoading}
          className="btn btn-outline"
        >
          <HiArrowLeft className="mr-2 h-5 w-5" />
          Anterior
        </button>
      )}

      {/* Spacer se for primeira etapa */}
      {isFirstStep && <div />}

      {/* Botão Próxima ou Enviar */}
      {!isLastStep ? (
        <button
          type="button"
          onClick={onProxima}
          disabled={isLoading}
          className="btn btn-primary"
        >
          {isLoading ? (
            <>
              <span className="loading loading-spinner"></span>
              Salvando...
            </>
          ) : (
            <>
              Próximo
              <HiArrowRight className="ml-2 h-5 w-5" />
            </>
          )}
        </button>
      ) : (
        <button
          type="button"
          onClick={onFinalizar}
          disabled={isLoading}
          className="btn btn-success"
        >
          {isLoading ? (
            <>
              <span className="loading loading-spinner"></span>
              Enviando...
            </>
          ) : (
            <>
              <HiCheckCircle className="mr-2 h-5 w-5" />
              Enviar Orçamento
            </>
          )}
        </button>
      )}
    </div>
  );
};
